import { render, staticRenderFns } from "./appTypeSelect.vue?vue&type=template&id=58d48350"
import script from "./appTypeSelect.vue?vue&type=script&lang=js"
export * from "./appTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./appTypeSelect.vue?vue&type=style&index=0&id=58d48350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports